 import React, {useRef, useEffect, useState} from 'react';
import checkSeveral from '../icons/CheckSeveral.svg'
import Down from '../icons/Down.svg'
import ResultComponent from './ResultComponent';
import Modal from '../Modal';
import AddVideoToPlaylistContent from '../playlistAdds/AddVideoToPlaylistContent';
import useWindowDimentions from '../hooks/useWindowDimentions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useNavigationType } from 'react-router-dom';
import { formatSeconds } from '../../utils/formatTime'


const Results = (props) => {

    const [checkActive, setCheckActive] = useState(false)

    const [videoList, setVideoList] = useState([])

    const [chosenDuration, setChosenDuration] = useState(0)

    const [selected, setSelected] = useState(false)

    const [addActive, setAddActive] = useState(false)

    const [right, setRight] = useState(0)

    const {width, height} = useWindowDimentions()

    const [top, setTop] = useState(0)

    const { user } = useSelector(state=>state.user)

    const dispatch = useDispatch()

    const navigationType = useNavigationType();

    const containerRef = useRef(null);

    const selectAllHandler = () => {
        setCheckActive(true)
        if(selected){
            setVideoList([])
            setChosenDuration(0)
        } else {
            setVideoList(props.data.map(i=>i.id))
            setChosenDuration(props.data.reduce((total, video) => total + video.duration, 0))
        }
        setSelected(!selected)
    }

    const addClickHandler = (e) => {
        if (e.clientX < 450){
            setRight(30)
        } else {
            setRight(width-e.clientX+5)
        }
        setTop(e.clientY)
        setAddActive(true)
    }


    useEffect(()=>{
        dispatch(props.searchFunc(props.val, 1, 0))
        dispatch(props.lengthFunc(props.val))
        props.setPage(1)
    },[props.val])


    const handleScroll = event => {

        const {scrollTop, clientHeight, scrollHeight} = event.currentTarget;
        sessionStorage.setItem("results-scroll", scrollTop);

        let h = Math.round(scrollHeight - scrollTop)
        if(h === clientHeight || h+1 === clientHeight || h-1 === clientHeight){
            dispatch(props.searchFunc(props.val, props.page+1, 1))
            props.setPage(prev => prev + 1)
        }
      }


    useEffect(()=>{
        setCheckActive(false)
        setVideoList([])
        setChosenDuration(0)
        if (navigationType === "POP") {
            const savedScroll = sessionStorage.getItem("results-scroll");
            if (containerRef.current && savedScroll !== null) {
            containerRef.current.scrollTo({
                top: parseInt(savedScroll, 10),
                behavior: "auto", // or 'smooth' if you want animation
            });
            }
        }
    },[props.data, navigationType])


    return (
        <>
            <div className = "container-fluid d-flex flex-column align-items-center"
            style={{ padding:0, margin:0}}>
                <div className = "w-100 d-flex flex-column align-items-center"
                    style={{maxHeight:"calc(100vh - 5rem)"}}
                >
                <div className='w-100 bg-dark top-0 d-flex justify-content-center'>
                    <div className='col-12 col-lg-10 px-1 px-lg-4 py-2 d-flex flex-column flex-md-row justify-content-between align-items-center'>
                        <div className = "text-info pt-2 fs-4">{props.title}</div>
                        <div className='d-flex flex-column flex-md-row align-items-md-center'>
                            <div className='d-flex align-items-start'>
                                {
                                    checkActive && videoList && videoList.length ?
                                    <>
                                        <div className = "text-info px-3 text-nowrap">{videoList.length} Videos</div>
                                        <div className = "text-info px-3 border-start border-info text-nowrap">{formatSeconds(chosenDuration)} </div>

                                    </> :
                                    props.info && props.info.count?
                                    <>
                                        <div className = "text-info px-3 text-nowrap">{props.info.count} Videos</div>
                                        <div className = "text-info px-3 border-start border-info text-nowrap">{formatSeconds(props.info.duration)} </div>

                                    </>: ""
                                }
                            </div>
                            {
                                user && user.first_name ?
                                    <div className='d-flex align-items-center' style={{gap:"1rem"}}>
                                {
                                    checkActive ?
                                    <>
                                        <div
                                            role = "button"
                                            className='rounded-pill px-3 py-1 d-flex'
                                            style={videoList && videoList.length ? {background:"#FFCD00", gap:"0.5rem"} :{background:"#708090", gap:"0.5rem"}}
                                            onClick={videoList && videoList.length ? (e)=>addClickHandler(e): ()=>{alert('please, choose a video')}}
                                            >
                                            <div>Add to</div>
                                            <img src={Down}
                                            alt=''
                                            />
                                        </div>
                                        <div
                                            style={{color:"#FFCD00"}}
                                            role='button'
                                            onClick={()=>{setCheckActive(false); setVideoList([]); setChosenDuration(0)}}>Exit</div>
                                        </>:
                                    <button
                                        className='rounded-pill px-4 py-1'
                                        style={{background:"#FFCD00"}}
                                        onClick={()=>setCheckActive(!checkActive)}
                                        >Select</button>
                                }
                                <div className='d-flex'
                                    role='button'
                                    onClick = {()=>selectAllHandler()}>
                                    <div
                                        style={{color:"#FFCD00"}}
                                        >All</div>
                                    <img
                                        className='px-1'
                                        alt = ''
                                        src = {checkSeveral} />
                                </div>
                            </div> : ''
                            }
                        </div>
                    </div>
                </div>
                <div className='col-12 col-lg-10 px-4 d-flex my-3 flex-row flex-wrap results-wrapper'
                    ref={containerRef}
                    onScroll = {handleScroll}>
                    {
                        props.data && props.data.length ?
                        props.data.map((result, index) => (
                            <div key = {index}
                                className = {videoList.includes(result.id) ?
                                    "col-6 col-md-4 col-lg-3 px-1 py-2 d-flex align-items-start bg-secondary border border-primary":
                                    "col-6 col-md-4 col-lg-3 px-1 py-2 d-flex align-items-start"}
                                >
                                <ResultComponent
                                    checkActive = {checkActive}
                                    result = {result}
                                    setVideo = {props.setVideo}
                                    setVideoList = {setVideoList}
                                    videoList = {videoList}
                                    setChosenDuration = {setChosenDuration}
                                />
                            </div>

                        )) : ""
                    }
                    {
                        props.loading && <div className = "text-info col-12 col-lg-10" >Loading...</div>
                    }
                </div>

                </div>
                <Modal
                    trigger = {addActive}
                    setTrigger = {setAddActive}
                    top = {top}
                    right = {right}
                    content = {
                        <AddVideoToPlaylistContent
                            setIsActive = {setAddActive}
                            video_list = {videoList}
                            index = {2}
                        />
                    }
                />
            </div>
        </>
    );
}

export default Results;